/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useCallback } from 'react';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useLocation } from 'react-use';
import { NextSeo } from 'next-seo';
import { getAppsSource } from '@/request/login';
import DownloadPage from '@/components/Download';
// import useHideIm from '@/hooks/useHideIm';
import Layout from '@/components/Layout';
import type { DownloadSource } from '@/components/Download/data';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  // Get external data from the file system, API, DB, etc.

  // The value of the `props` key will be
  //  passed to the `Home` component
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'download', 'path', 'form'])),
    },
  };
};

const Download = () => {
  const { t } = useTranslation(['download', 'common']);
  const state = useLocation();

  const [downloadSource, setDownloadSource] = useState<DownloadSource | null>();

  const getAppsSourceCallback = useCallback(async () => {
    const data = await getAppsSource();
    setDownloadSource(data);
  }, []);

  useEffect(() => {
    getAppsSourceCallback();
  }, [getAppsSourceCallback]);

  if (!downloadSource) {
    return null;
  }
  // useHideIm(isApp);

  return (
    <div className="min-h-96 w-full">
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-下载中心-title'),
          description: t('common:seo-下载中心-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-下载中心-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-下载中心-title')}</title>
        <meta name="description" content={t('common:seo-下载中心-description')} />
        <meta name="keywords" content={t('common:seo-下载中心-关键词')} />
        <script defer src="https://www.eeo.cn/partner/api/geturl_classindownload.js" />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-下载中心-title')}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'SoftwareApplication',
              name: 'WuKong Class',
              operatingSystem: 'WINDOWS, MAC, iOS, ANDROID',
              applicationCategory: 'EducationApplication',
              aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: '4.7',
                ratingCount: '16609',
              },
              offers: {
                '@type': 'Offer',
                price: '0.00',
                priceCurrency: 'USD',
              },
            }),
          }}
        />
      </Head>
      <div className="l:min-h-96 l:pb-[220px] min-h-36 pt-[85px] xl:min-h-96  xl:pb-[220px] xl:pt-[0]">
        <DownloadPage downloadSource={downloadSource} />
      </div>
    </div>
  );
};

export default Download;

Download.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
